import { render, staticRenderFns } from "./DispatchStatisticsData.vue?vue&type=template&id=3e5bd95d&scoped=true"
import script from "./DispatchStatisticsData.vue?vue&type=script&lang=js"
export * from "./DispatchStatisticsData.vue?vue&type=script&lang=js"
import style0 from "./DispatchStatisticsData.vue?vue&type=style&index=0&id=3e5bd95d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5bd95d",
  null
  
)

export default component.exports